import { Dispatch, SetStateAction } from 'react';
import {
  EducationalStage,
  Gender,
  IAddress,
  LocationOfCourse,
  PartOfTheDay,
} from '@les-sherpas/sherpas-toolbox';

export const indifferentLocationOfCourse = 'indifferent';
export type IndifferentLocationOfCourse = typeof indifferentLocationOfCourse;
export type SidePanelFilters = {
  educationalStages: EducationalStage[];
  prices: [number, number];
  courseLocation: LocationOfCourse | IndifferentLocationOfCourse;
  gender: Gender;
  availabilities: PartOfTheDay[];
  onlyCertifiedSherpas: boolean;
  onlyAvailableSherpas: boolean;
  onlyAnswerFastSherpas: boolean;
};

export type SearchFiltersType = {
  subject: string;
  address: IAddress;
  sidePanelFilters: SidePanelFilters;
  setSubject: Dispatch<SetStateAction<string>>;
  setAddress: Dispatch<SetStateAction<IAddress>>;
  setSidePanelFilters: Dispatch<SetStateAction<SidePanelFilters>>;
  debounce: {
    minPrice: number;
    maxPrice: number;
    subject: string;
    address: IAddress;
    sidePanelFilters: SidePanelFilters;
  };
};

export type SearchSortType = {
  criteria: number;
  setCriteria: Dispatch<SetStateAction<number>>;
  debounce: {
    criteria: number;
  };
};

export type SearchDefaultProps = {
  defaultAddress?: string;
  defaultSubject?: string;
};

export type SearchFiltersSortDebounceType = {
  filters: SearchFiltersType['debounce'];
  sort: SearchSortType['debounce'];
};
